var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPortfolio = function SvgPortfolio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Portfolio---main-view-Copy",
    transform: "translate(-20.000000, -364.000000)",
    fill: "#0086D8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portfolio",
    transform: "translate(0.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4,4 L22.6,4 C23.9254834,4 25,5.0745166 25,6.4 L25,25.6 C25,26.9254834 23.9254834,28 22.6,28 L8.4,28 C7.0745166,28 6,26.9254834 6,25.6 L6,6.4 C6,5.0745166 7.0745166,4 8.4,4 Z M21.4375,22.48 L21.4375,23.68 L9.5625,23.68 L9.5625,22.48 L21.4375,22.48 Z M21.4375,19.6 L21.4375,20.8 L9.5625,20.8 L9.5625,19.6 L21.4375,19.6 Z M21.4375,16.72 L21.4375,17.92 L9.5625,17.92 L9.5625,16.72 L21.4375,16.72 Z M13.29807,7.6 L15.5,13.3748918 L14.112013,13.3748918 L13.7607323,12.3965368 L11.3103355,12.3965368 L10.950487,13.3748918 L9.5625,13.3748918 L11.7729978,7.6 L13.29807,7.6 Z M20.1015625,8.8 L20.1015625,10.15 L21.4375,10.15 L21.4375,11.05 L20.1015625,11.05 L20.1015625,12.4 L19.2109375,12.4 L19.2109375,11.05 L17.875,11.05 L17.875,10.15 L19.2109375,10.15 L19.2109375,8.8 L20.1015625,8.8 Z M12.5355339,8.82943723 L11.6444805,11.3142857 L13.4265873,11.3142857 L12.5355339,8.82943723 Z",
    id: "ic_check_box_outline_blank_24px"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPortfolio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/portfolio.da02f6c2.svg";
export { ForwardRef as ReactComponent };